import { ITEM_STATE_DELETING } from "../../constants";

export default ({ itemState }) => itemState === ITEM_STATE_DELETING;
